import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

const Document = ({
  size, color, theme, iconTitle,
}) => {
  const iconColor = color || (theme && theme.iconColor);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={iconColor}
      strokeWidth="2"
    >
      <title>{iconTitle}</title>
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
      <polyline points="10 9 9 9 8 9" />
    </svg>
  );
};

Document.propTypes = {
  color: PropTypes.string,
  iconTitle: PropTypes.string,
  size: PropTypes.number,
  theme: PropTypes.object,
};

Document.defaultProps = {
  color: null,
  iconTitle: null,
  size: 26,
  theme: null,
};

export default withTheme(Document);
